import { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';

type CompProps = {
    iconContainerBgClassName?: string;
    icon: ReactNode;
    headingText: string;
    children: ReactNode;
    renderHeaderRight?: React.FC;
    renderHeaderLeft?: React.FC;
    bodyCssClassName?: string;
    headerCssClassName?: string;
    style?: { [k: string]: string };
    headingTextCssClassName?: string;
    id?: string;
};

type Props = CompProps;

class PadV2PxElementCard extends PureComponent<Props> {
    render(): ReactNode {
        const {
            children,
            headingText,
            icon,
            iconContainerBgClassName,
            renderHeaderRight,
            renderHeaderLeft,
            bodyCssClassName,
            headerCssClassName,
            style,
            headingTextCssClassName,
            id,
        } = this.props;

        return (
            <div
                className={`pt-8 px-16 pb-16 bg-white row focusable w-full ${
                    bodyCssClassName || 'rounded-8'
                }`}
                style={style}
                id={id}
            >
                <div className={`flex items-center justify-between ${headerCssClassName || ''}`}>
                    <div className="space-x-10 flex items-center">
                        {icon && (
                            <div
                                className={`rounded-4 min-w-26 h-26 flex items-center justify-center ${iconContainerBgClassName}`}
                            >
                                <div className="w-11 h-12 flex items-center justify-center">
                                    {icon}
                                </div>
                            </div>
                        )}
                        <p
                            className={`font-700 text-16 text-neutral-1000 ${
                                headingTextCssClassName || ''
                            }`}
                        >
                            {headingText}
                        </p>
                        {renderHeaderLeft && renderHeaderLeft({})}
                    </div>
                    {renderHeaderRight && renderHeaderRight({})}
                </div>
                {children}
            </div>
        );
    }
}

export default connect(() => ({}))(PadV2PxElementCard);
